import DocumentUpload from "./documentUpload";
export default DocumentUpload;